export async function singleselect(fieldId: string, value: string, data: { [key: string]: Object }[], hasError: boolean, filter: boolean = false) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap4.css');
    await import('@syncfusion/ej2-lists/styles/bootstrap4.css');
    await import('@syncfusion/ej2-dropdowns/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { DropDownList } = await import('@syncfusion/ej2-dropdowns');
    const { Query } = await import('@syncfusion/ej2-data');


    const containerEle = document.getElementById('container_' + fieldId);
    const inputEle = document.getElementById('input_' + fieldId);

    const dataEle = document.getElementById('data_' + fieldId);
    if (containerEle.hasAttribute("data-singledropdownlist")) {
        (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        return;
    }

    containerEle.setAttribute('data-singledropdownlist', 'true');

    let ddObject = new DropDownList({
        // sets the placeholder
        floatLabelType: "Never",
        placeholder: "Please choose...",
        dataSource: data,
        fields: { text: 'Text', value: 'Value' },
        value: value,
        change: (args: any) => {
            dataEle.setAttribute('value', ddObject.value?.toString());
            ((window as any).htmx as any).trigger('#updatebutton', 'click');
        },
        created: (args: any) => {
            (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
            containerEle.style.display = null;
        },
        allowFiltering: filter,
        // Filtering event handler
        filtering: function (e) {
            var query = new Query();
            // Frame the query based on search string with filter type.
            query = (e.text !== '') ? query.where('text', 'contains', e.text, true) : query;
            // Pass the filter data source and query to updateData method.
            e.updateData(ddObject.dataSource, query);
        }
    });
    ddObject.appendTo('#input_' + fieldId);

    containerEle.onclick = () => { ddObject.showPopup(); };
}